import React, { useContext, useEffect, useState } from "react"
import { Heading2 } from "../typography/headings"
import { Modal } from "../Modal"
import { BodyTextRegular } from "../typography/text"
import { CheckboxField } from "../forms/fields/CheckboxField"
import { InterfaceContext } from "../../context/InterfaceContext"
import {
  allPreferencesAccepted,
  CookieCategories,
  initialPreferences,
  saveCookiePreferences,
} from "./utils"
import { ButtonAction } from "../button/ButtonAction"
import { translationKeys } from "../../util/translationKeys"
import { useTranslation } from "react-i18next"

export const CookieModal = () => {
  const { t } = useTranslation()

  const { cookieModalVisible, setCookieModalVisible, setCookieBannerVisible } =
    useContext(InterfaceContext)

  const [preferences, setPreferences] =
    useState<CookieCategories>(initialPreferences)

  useEffect(() => {
    const cookiePreferencesString = localStorage.getItem("cookiePreferences")
    if (!cookiePreferencesString) {
      return
    }
    const cookiePreferences: CookieCategories = JSON.parse(
      cookiePreferencesString
    )
    setPreferences(cookiePreferences)
  }, [cookieModalVisible])

  const togglePreference = (preferenceName: string) => {
    setPreferences({
      ...preferences,
      [preferenceName]: !(preferences as any)[preferenceName],
    })
  }

  return (
    <Modal
      className="relative md:w-[650px] w-full p-6"
      isOpen={cookieModalVisible}
      onClose={() => {
        const cookiePreferencesString =
          localStorage.getItem("cookiePreferences")

        if (!cookiePreferencesString) {
          setCookieBannerVisible(true)
        }

        setCookieModalVisible(false)
      }}
    >
      <div className="gap-6 flex flex-col">
        <Heading2>{t(translationKeys.comboCookiesInsuranceText)}</Heading2>
        <BodyTextRegular>
          {t(translationKeys.webCookiePreferencesSubtitle)}
        </BodyTextRegular>
        <div className="flex flex-col gap-3 my-5">
          <div className="flex flex-row gap-2 items-center">
            <CheckboxField
              disabled
              label={t(translationKeys.inputRequired) || "Required"}
              checked={true}
            />
          </div>
          <div className="flex flex-row gap-2 items-center">
            <CheckboxField
              label={t(translationKeys.comboAnalytics) || "Analytics"}
              checked={!!preferences.analytics}
              onChange={() => togglePreference("analytics")}
            />
          </div>
          <div className="flex flex-row gap-2 items-center">
            <CheckboxField
              label={t(translationKeys.comboMarketing) || "Marketing"}
              checked={!!preferences.marketing}
              onChange={() => togglePreference("marketing")}
            />
          </div>
        </div>
        <div className="gap-2 flex justify-end">
          <ButtonAction
            size="large"
            onClick={() => {
              saveCookiePreferences(preferences)
              setCookieModalVisible(false)
            }}
          >
            {t(translationKeys.ctaSavePreferences)}
          </ButtonAction>
          <ButtonAction
            onClick={() => {
              saveCookiePreferences(allPreferencesAccepted)
              setCookieModalVisible(false)
            }}
            size="large"
          >
            {t(translationKeys.ctaAcceptAll)}
          </ButtonAction>
        </div>
      </div>
    </Modal>
  )
}
